import { useGameStore } from '../GameStoreContext.ts';
import { isVotePendingForViewer } from './VotePending.ts';
export const useIsMyVotePending = ()=>{
    const voteState = useGameStore((state)=>state.gameVote.voteState);
    const myColor = useGameStore((state)=>state.myColor);
    return isVotePendingForViewer(voteState, myColor);
};
